<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <LogInIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('admin.role.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0"></div>
    </div>
    <div class="intro-y box p-5 mt-5">
      <RoleTable />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import RoleTable from '@/components/security/RoleTable'

export default defineComponent({
  components: {
    RoleTable
  },
  setup() {
    return {}
  }
})
</script>
